import React from "react";
import { motion } from "framer-motion";

const SocialIconButton = ({ href, Icon }) => {
  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="relative bg-transparent border border-brand/40 text-[#151515] hover:border-brand rounded-full w-9 h-9 inline-flex items-center justify-center shadow-none z-10 touch-manipulation"
      aria-label="Social Media Link"
      variants={{
        hover: { scale: 1.16, rotate: 12, boxShadow: "0 1px 5px #a2a2a2" },
        initial: { scale: 1, rotate: 0 },
      }}
      initial="initial"
      whileHover="hover"
      whileTap={{ scale: 0.94, rotate: -12 }}
      transition={{ type: "spring", stiffness: 400, damping: 24 }}
      style={{ WebkitTapHighlightColor: "transparent" }}
    >
      {/* Animierte Ringe */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        {[...Array(2)].map((_, index) => (
          <motion.div
            key={index}
            className="absolute rounded-full "
            style={{ width: "55%", height: "55%" }}
            initial={{ scale: 0.2, opacity: 0.5 }}
            animate={{ scale: 1.4, opacity: 0 }}
            transition={{
              duration: 2,
              repeat: Infinity,
              repeatType: "loop",
              delay: index * 0.5,
            }}
          />
        ))}
      </div>

      <span className="relative z-20">
        <motion.span
          whileHover={{ scale: 1.18, rotate: 12 }}
          whileTap={{ scale: 0.95, rotate: -8 }}
          transition={{ type: "spring", stiffness: 400, damping: 22 }}
        >
          <Icon size={15} />
        </motion.span>
      </span>
    </motion.a>
  );
};

export default SocialIconButton;
